import { NgModule } from '@angular/core';
import { LifecycleStageNamePipe } from './lifecycle-stage.pipe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [TranslateModule],
  declarations: [LifecycleStageNamePipe],
  exports: [LifecycleStageNamePipe],
})
export class LifecycleStagePipeModule {}
